
import {
  Container,
  Grid,
  Tooltip,
  Switch,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "../../components/table/Table";
import {  Delete } from "@mui/icons-material";
import CreateModel from "./CreateModel";
import {
  deleteClient,
  getAllClients,
  updateStatus,
} from "../../redux/actions/client.actions";
import { useDispatch, useSelector } from "react-redux";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import StatsCard from "../../components/Comman/cards";
import CardWithButton from "../../components/Comman/button-new";
import PersonIcon from '@mui/icons-material/Person'
import { toast } from "react-toastify";

const ClientBusiness = () => {
  const { clients } = useSelector((state) => state.clientReducer);
  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);
  const [updateData, setUpdatedata] = useState(null);
  const [rows, setRows] = useState([]);
  const active = clients
    .map((item) => item.status)
    .filter((item) => item === 1);

  useEffect(() => {
    dispatch(getAllClients());
  }, []);

  useEffect(() => {
    const formattedRows = clients.map((item) => ({
      ...item,
      id: item.client_id,
    }));
    setRows(formattedRows);
  }, [clients]);

  const handleEdit = (id) => {
    handleModal(true);
    setEdit(true);
    const filterData = clients.find((e) => e.client_id === id);
    setUpdatedata(filterData);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    {
      field: "name",
      headerName: "Client Name",
      flex: 1,
      editable: true,
    },
    {
      field: "logo",
      headerName: "Logo",
      flex: 0.7,
      editable: true,
      renderCell: (params) => (
        params?.value?.startsWith("https") ?
          <img
            src={params.value}
            alt="icon"
            style={{ width: 50, height: 50, borderRadius: "50%", objectFit: "contain" }}
          /> :
          // <Tooltip title="View more">
          //   <Button
          //     href={`${params.row.logo}`}
          //     target="_blank"
          //     startIcon={<Visibility />}
          //   ></Button>
          // </Tooltip>
          <>
            <span>N/C</span>
          </>
      ),
    },
    {
      field: "icon",
      headerName: "Icon",
      flex: 0.7,
      editable: false,
      renderCell: (params) => (
        params?.value?.startsWith("https") ?
          <img
            src={params.value}
            alt="icon"
            style={{ width: 50, height: 50, borderRadius: "50%", objectFit: "contain" }}
          /> :
          // <Tooltip title="View more">
          //   <Button
          //     href={`${params.row.logo}`}
          //     target="_blank"
          //     startIcon={<Visibility />}
          //   ></Button>
          // </Tooltip>
          <>
            <span>N/C</span>
          </>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      sortable: true,
      flex: 0.5,
      editable: false,
      renderCell: (params) => (
        <Tooltip title="Change Status">
          <Switch
            checked={params.row.status}
            onClick={() => handleStatusChange(params.id, params.row.status)}
            name="status"
            style={{color:"rgba(0, 165, 162, 1)"}}
          />
        </Tooltip>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <>
          <Box>
            <Tooltip title="Edit brand">
              <ModeEditIcon onClick={() => handleEdit(params.row.client_id)} color="success"/>
            </Tooltip>
          </Box>
          <Box>
            <Tooltip title="Delete brand">
              <IconButton
                onClick={() => {
                  handleDelete(params.row.client_id);
                }}
                color="error"
              >
                <Delete />
              </IconButton>
            </Tooltip>
          </Box>
        </>
      ),
    },
  ];

  const [openModal, setOpenModal] = useState(false);

  const handleModal = (value) => {
    setOpenModal(value);
  };

  const handleStatusChange = (id, statusVal) => {
    const status = statusVal === 1 ? 0 : 1;
    dispatch(updateStatus(id, status)).then((res) => {
      if (res.status === 200) {
        toast.success(res.data.message);
        dispatch(getAllClients());
      }
    });
  };

  const handleDelete = (id) => {
    dispatch(deleteClient(id));
  };

  return (
    <Container style={{
      border: "1px solid rgba(0, 0, 0, 0.1)",
      padding: "20px 0px 20px 20px",
      width: "98%",
      marginBottom:"5%"
    }}
      className="shadow-md bg-white rounded ">
      <Grid container direction="column" spacing={5}>
        <Grid
          container
          Item
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
        >
          <StatsCard heading="TOTAL CLIENT" icon={<WorkIcon />} content={clients.length} />
          <StatsCard heading="ACTIVE CLIENT" icon={<PersonIcon />} content={active.length} />
        </Grid>
        <Grid item>
          <CardWithButton
            title="Create Client Business"
            className=""
            buttonLabel="Create Client "
            buttonIcon={<AddIcon />}
            buttonClick={() => handleModal(true)}
          />
        </Grid>
        <Grid item>
          <Table rows={rows} columns={columns} />
        </Grid>
      </Grid>
      {openModal && (
        <CreateModel
          handleModal={handleModal}
          openModal={openModal}
          edit={edit}
          setEdit={setEdit}
          updateData={updateData}
          setUpdatedata={setUpdatedata}
        />
      )}
    </Container>
  );
};

export default ClientBusiness;
